//const baseapi='http://localhost:8880/v1';
//const baseapi='http://39.108.113.20:8880/v1';
const baseapi='/api/cdn';

const cdn=baseapi+'/'
const publicFile=cdn+'public/'
const base64=cdn+'base64/'

export default {
  cdn,
  publicFile,
  base64
}
